<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import type { MembershipRoleChoiceResponse } from "@kontextwerk/control-web-client"
  import { roleLabel } from "../../../../../../../../_shared/_logic/role-presentation"
  import type { UserCreateForm } from "../../_shared/_logic/user-create-workflow"

  const {
    form,
    choices,
    busy = false,
    readOnly = false,
    onFormChange,
  }: {
    form: UserCreateForm
    choices: readonly MembershipRoleChoiceResponse[]
    busy?: boolean
    readOnly?: boolean
    onFormChange: (form: UserCreateForm) => void
  } = $props()

  const roleOptions = $derived(
    choices.map((choice) => ({ value: choice.id, name: roleLabel(choice) ?? choice.name })),
  )
  const disabled = $derived(busy || readOnly)

  const patchForm = (patch: Partial<UserCreateForm>) => {
    onFormChange({ ...form, ...patch })
  }
</script>

<div class="user-create-data form light">
  <div class="row">
    <Input
      type="text"
      placeholder="E-Mail"
      autocomplete="email"
      value={form.email}
      maxlength={320}
      {disabled}
      brightBackground={true}
      onChange={(event) =>
        patchForm({ email: (event.target as HTMLInputElement | null)?.value ?? "" })}
      dataTestid="controlAdmin.users.invite.emailInput"
    />
    <Input
      type="select"
      options={roleOptions}
      value={form.roleId}
      placeholder="Rolle"
      clearable={false}
      {disabled}
      brightBackground={true}
      tooltip="Die Rolle legt fest, welche Berechtigungen die eingeladene Person nach dem Annehmen erhält."
      onValueChange={(value) => patchForm({ roleId: String(value ?? "") })}
      dataTestid="controlAdmin.users.invite.roleSelect"
    />
  </div>
</div>

<style lang="less">
  .user-create-data {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-top: 0.4rem;

    .row {
      padding: 0;
    }
  }
</style>
